import { useState } from "react";
import ErrorBoundary from "@/components/ErrorBoundary";
import { RacePredictions } from "@/components/RacePredictions";

function App() {
  return (
    <div className="min-h-screen bg-background">
      <header className="border-b bg-primary text-primary-foreground sticky top-0 z-10 shadow-sm">
        <div className="container mx-auto py-4 px-4 md:px-6">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between">
            <div>
              <h1 className="text-2xl font-bold flex items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="mr-2"
                >
                  <path d="M19 7H5a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2Z" />
                  <path d="M17 2H7a1 1 0 0 0-1 1v4h12V3a1 1 0 0 0-1-1Z" />
                  <path d="M12 10v6" />
                  <path d="m9 13 3-3 3 3" />
                </svg>
                Racing Prediction Results
              </h1>
              <p className="text-sm opacity-80 mt-1">
                Historical performance of Australian racing predictions
              </p>
            </div>
            <div className="mt-2 md:mt-0">
              <div className="inline-flex items-center px-3 py-1 rounded-full bg-primary-foreground/20 text-primary-foreground text-sm">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="mr-1"
                >
                  <path d="M12 2v1" />
                  <path d="M12 21v-1" />
                  <path d="M4.93 4.93l.7.7" />
                  <path d="M18.36 18.36l.7.7" />
                  <path d="M2 12h1" />
                  <path d="M21 12h-1" />
                  <path d="M4.93 19.07l.7-.7" />
                  <path d="M18.36 5.64l.7-.7" />
                  <circle cx="12" cy="12" r="4" />
                </svg>
                Powered by Staible Returns
              </div>
            </div>
          </div>
        </div>
      </header>
      <main className="container mx-auto py-6 px-4 md:px-6">
        <div className="mb-6">
          <h2 className="text-xl font-semibold mb-2">
            Racing Prediction Archive
          </h2>
          <p className="text-muted-foreground">
            View historical racing predictions and their outcomes. Predictions
            are grouped by date and track.
          </p>
        </div>
        <ErrorBoundary>
          <RacePredictions />
        </ErrorBoundary>
      </main>
      <footer className="border-t mt-8 py-6 bg-muted/30">
        <div className="container mx-auto text-center text-sm text-muted-foreground px-4 md:px-6">
          <div className="flex flex-col md:flex-row md:justify-between md:items-center">
            <p>
              © {new Date().getFullYear()} Racing Predictions. Data provided by
              Staible Returns.
            </p>
            <div className="mt-2 md:mt-0 flex items-center justify-center space-x-4">
              <a href="#" className="hover:text-primary transition-colors">
                Terms
              </a>
              <a href="#" className="hover:text-primary transition-colors">
                Privacy
              </a>
              <a href="#" className="hover:text-primary transition-colors">
                Contact
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
